import Constants from 'expo-constants';

export interface AppsFlyerConfig {
  devKey: string;
  isDebug: boolean;
  oneLinkURL: string;
  oneLinkTemplateId: string;
  appId: {
    ios: string;
    android: string;
  };
}

const extraConfig = Constants.expoConfig?.extra?.appsflyer || {};

export const appsFlyerConfig: AppsFlyerConfig = {
  devKey: extraConfig.devKey || process.env.EXPO_PUBLIC_APPSFLYER_DEV_KEY || '',
  isDebug: __DEV__,
  oneLinkURL: extraConfig.oneLinkURL || process.env.EXPO_PUBLIC_APPSFLYER_ONELINK_URL || '',
  oneLinkTemplateId: extraConfig.oneLinkTemplateId || process.env.EXPO_PUBLIC_APPSFLYER_ONELINK_TEMPLATE_ID || '',
  appId: {
    ios: 'com.gethabitcoach.ios2',
    android: 'com.gethabitcoach.android2',
  },
};

export const buildOneLinkURL = (installToken: string, platform: 'ios' | 'android'): string => {
  const params = new URLSearchParams({
    deep_link_value: `installToken=${installToken}`,
    af_dp: `mentorist://install?token=${installToken}`,
    af_force_deeplink: 'true',
  });
  
  const fullURL = `${appsFlyerConfig.oneLinkURL}?${params.toString()}`;
  console.log('[AppsFlyer] OneLink URL:', fullURL);
  console.log('[AppsFlyer] Token:', installToken);
  
  return fullURL;
};
